import { useEffect, useState } from "react";
import { api } from "../../api/client";

// 側邊欄「更新紀錄」旁的紅點(業主 2026-09-28:「紅色實心小圓 裡面有數字」)。
//
// **不走 react-query**:側邊欄長在 `AppShell` 上,幾乎每一支元件測試都會掛它 ——
// 在這裡要一個 QueryClientProvider 等於逼每一支測試都包一層(與公司名稱同一個慣例)。
// 讀不到就當 0:紅點畫錯比不畫糟。

/** 更新紀錄頁標完「看過」之後廣播這個事件,側邊欄聽到就歸零。 */
export const CHANGELOG_SEEN_EVENT = "nebula:changelog-seen";

export function useUnreadUpdates(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    void api
      .get<{ unread?: number }>("/changelog/unread")
      .then((got) => {
        if (alive) setCount(Math.max(0, Number(got?.unread) || 0));
      })
      .catch(() => {});
    const reset = () => setCount(0);
    window.addEventListener(CHANGELOG_SEEN_EVENT, reset);
    return () => {
      alive = false;
      window.removeEventListener(CHANGELOG_SEEN_EVENT, reset);
    };
  }, []);
  return count;
}
